// executiveDashboard module mutations.js
export default {
  setBrands(state, brands) {
    state.brands = brands;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
  setExecutiveSummaries(state, summaries) {
    state.executiveSummaries = summaries;
  },
  setProducts(state, products) {
    state.products = products;
  }
}
